import { useContext, useEffect } from 'react';
import { useLazyQuery } from '@apollo/client';
import { useQuery } from './useQuery';
import getServiceAddOnsQuery from '../queries/service-add-ons/serviceAddOnsQuery';
import { ExperienceContext } from '~/@thd-nucleus/experience-context';

const useServiceAddOns = ({
  itemId, storeId, ssr = false, lazy = false, skip = false
}) => {
  let sId = storeId;
  const ctx = useContext(ExperienceContext);
  if (!sId && ctx && ctx.store) {
    sId = ctx.store.storeId;
  }
  const options = {
    ssr,
    skip,
    lazy,
    errorPolicy: 'all',
    variables: {
      itemId,
      storeId: sId
    }
  };
  const Query = getServiceAddOnsQuery();

  if (lazy) return useLazyQuery(Query, options);

  const resp = useQuery(Query, options);
  useEffect(() => {
    if (typeof window !== 'undefined' && window.LIFE_CYCLE_EVENT_BUS && resp.data && !resp.loading) {
      const { data } = resp;

      window.LIFE_CYCLE_EVENT_BUS.trigger('data-sources.data', {
        type: 'serviceAddons',
        variables: options.variables,
        data
      });
    }
    if (typeof window !== 'undefined' && window.LIFE_CYCLE_EVENT_BUS && resp.error && !resp.loading) {
      const { data } = resp;

      window.LIFE_CYCLE_EVENT_BUS.trigger('data-sources.error', {
        type: 'serviceAddons',
        variables: options.variables,
        data
      });
    }
  }, [resp.loading]);

  return resp;
};

export default useServiceAddOns;
